import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ImagePlus } from "lucide-react";

export default function CreateGroup() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [rules, setRules] = useState("");
  const [image, setImage] = useState("");
  const [joinCost, setJoinCost] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!title.trim()) return toast.error("Title required");
    setLoading(true);
    try {
      const res = await api.post("/groups", {
        title,
        description,
        rules,
        image,
        join_cost: joinCost,
      });
      toast.success("Group created!");
      navigate(`/groups/${res.data.group_id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Creation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7]">
      <Navbar />
      <main className="max-w-xl mx-auto px-4 py-8">
        <h1 className="font-display text-2xl font-semibold mb-6">Create a Group</h1>
        <form onSubmit={handleCreate} className="bg-white border border-[#E7E5E0] rounded-2xl p-6 space-y-4">
          <div>
            <label className="text-xs font-semibold uppercase">Group Image</label>
            <div className="mt-2 flex items-center gap-4">
              <div className="w-20 h-20 rounded-xl overflow-hidden border bg-[#F5F3EE] flex items-center justify-center">
                {image ? (
                  <img src={image} alt="" className="w-full h-full object-cover" />
                ) : (
                  <ImagePlus className="w-6 h-6 text-[#6B6B70]" />
                )}
              </div>
              <input type="file" accept="image/*" onChange={handleImageUpload} />
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold uppercase">Title</label>
            <input value={title} onChange={e => setTitle(e.target.value)} className="neo-input mt-1" placeholder="Group name" maxLength={100} />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase">Description</label>
            <textarea value={description} onChange={e => setDescription(e.target.value)} className="neo-input mt-1 h-24 resize-none" placeholder="What is this group about?" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase">Rules</label>
            <textarea value={rules} onChange={e => setRules(e.target.value)} className="neo-input mt-1 h-24 resize-none" placeholder="Group rules..." />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase">Join Cost (diamonds)</label>
            <input type="number" value={joinCost} onChange={e => setJoinCost(Math.max(0, parseInt(e.target.value) || 0))} className="neo-input mt-1" min="0" />
            <p className="text-[10px] text-[#6B6B70] mt-1">0 = free to join. Cost is paid by new members.</p>
          </div>
          <button type="submit" disabled={loading} className="neo-btn bg-purple-600 border-purple-600 w-full">
            {loading ? "Creating..." : "Create Group (10 💎)"}
          </button>
        </form>
      </main>
    </div>
  );
}